import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { saveAndContinueRehydrateSlice } from '../storeUtils';

interface TransactionState {
  transactionId: string | null;
}

const initialState: TransactionState = {
  transactionId: null,
};

const name = 'transaction';

export const slice = createSlice({
  name,
  initialState,
  selectors: {
    transactionId: (state) => state.transactionId,
  },
  reducers: {
    setTransactionId: (state, action: PayloadAction<string>) => {
      state.transactionId = action.payload;
    },
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, name);
  },
});

export const transactionSelectors = slice.selectors;
export const transactionSlice = slice;
